import Client from './MemberCard.Client';
import Member from './MemberCard.Member';

export const MemberBaseballCard = {
  Client,
  Member,
};